import {fetchAuthSession, fetchUserAttributes} from 'aws-amplify/auth';
import moment from 'moment';

import type {IUser} from 'types';

export const getUserAttributes = (currentUser: IUser) => ({
  userEmail: currentUser.attributes?.email || '',
  userPhone: currentUser.attributes?.phone_number || '',
  userId: currentUser.attributes?.sub || '',
  accountId: currentUser.attributes?.['custom:account_id'] || '',
  termsOfServiceUrl: currentUser.attributes?.['custom:tos_doc'] || '',
  termsOfServiceAcceptedAt: currentUser.attributes?.['custom:tos_accepted_at'] || '',
  accessLevel: currentUser.attributes?.['cognito:groups']?.[0] || '',
  identityId: currentUser.identityId as string | null | undefined
});

// Fetch current user with Amplify v6 format
export const fetchCurrentUser = async (forceRefresh = false): Promise<IUser | null> => {
  try {
    const session = await fetchAuthSession({forceRefresh});

    // Check if user is authenticated
    if (!session.tokens) {
      return null;
    }

    const attributes = await fetchUserAttributes();
    const idTokenPayload = session.tokens.idToken?.payload;
    const accessLevels = (idTokenPayload?.['cognito:groups'] as string[] | undefined) || [];

    return {
      attributes,
      accessLevels,
      identityId: session.identityId
    };
  } catch (error) {
    // Return null if user is not authenticated or session is expired
    console.error('Failed to fetch current user:', error);
    return null;
  }
};

export const isPasswordExpiring = (expiresAt: string, daysThreshold = 30): boolean => {
  try {
    const expiryDate = moment(expiresAt);

    if (!expiryDate.isValid()) {
      return false;
    }

    const daysUntilExpiry = expiryDate.diff(moment(), 'days');

    return daysUntilExpiry <= daysThreshold;
  } catch {
    // If date parsing fails, assume password is not expiring
    return false;
  }
};
